<template>
  <span class="checkbox-component" @click="handleClick">
    <span
      class="checkbox"
      :class="{'checked': iChecked, 'disabled': disabled, 'disabled-checked': checked && disabled}"
    ></span>
    <span class="label">{{ label }}</span>
    <span class="extra">
      <slot />
    </span>
  </span>
</template>

<script>
export default {
  name: 'checkbox-item',
  props: {
    label: String,
    onChange: Function,
    disabled: Boolean,
    checked: Boolean,
    value: Boolean,
  },

  data() {
    return {
      iChecked: this.checked
    }
  },
  methods: {
    handleClick() {
      if (this.disabled) {
        return
      }
      this.iChecked = !this.iChecked
      this.onChange && this.onChange(this.iChecked);
      this.$emit('input', this.iChecked);
    },
    updateValue(checked) {
      this.iChecked = checked;
    }
  },
  mounted() {
    this.updateValue(this.value);
  },
  watch: {
    checked(val, oldVal) {
      this.iChecked = val;
    },
    value(value) {
      this.updateValue(value);
    },
  }
}
</script>
<style lang="scss" scoped>
@import './style.scss';
</style>
